import { render, staticRenderFns } from "./HomeArea.vue?vue&type=template&id=232bdfad&scoped=true"
import script from "./HomeArea.vue?vue&type=script&lang=js"
export * from "./HomeArea.vue?vue&type=script&lang=js"
import style0 from "./HomeArea.vue?vue&type=style&index=0&id=232bdfad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232bdfad",
  null
  
)

export default component.exports